module.exports = __webpack_public_path__ + "static/media/telegraph.918fc3e6.jpg";